import React from "react";

import { NoteCellContent as Content } from "../components";

import base from "./base";

import { Column, ColumnId } from ".";

function note({ width, onResize }: Column.Options) {
	return base(ColumnId.Notes, (item) => <Content item={item} />, {
		width,

		onResize: onResize as (
			columnWidth?: number | undefined,
			dataKey?: string | undefined,
		) => void,
	});
}

export default note;
